import React from 'lib/react';
import {
  EVGrid, EVPaper, EVLink,
} from 'lib/components';
import Typography from 'commonComponents/typography';
import { useTranslation, Trans } from 'lib/translation';
import Banner from 'commonComponents/banner';
import { SUPPORT_CANADA_USERS } from 'constants/AppConstants';
import ManagePaymentOptionsStyles from '../ManagePaymentOptionsStyles';

function ManagePaymentOptionsUnvailable() {
  const { t } = useTranslation();
  const classes = ManagePaymentOptionsStyles();

  return (
    <>
      <Banner
        severity="error"
        message={t('manage_payment__custom_banner_msg')}
      />
      <EVGrid className={classes.managePaymentContainer}>
        <EVPaper className={classes.prePaymentPaper}>
          <Typography variant="body-400" fontColor="charcoal-900">
            <Trans
              i18nKey="manage_payment__not_available_text"
              components={{
                a: (
                  <EVLink
                    style={{ color: '#007CAD' }}
                    href={SUPPORT_CANADA_USERS}
                  >
                    Customer Service
                  </EVLink>
                ),
              }}
            />
          </Typography>
        </EVPaper>
      </EVGrid>
    </>
  );
}

export default ManagePaymentOptionsUnvailable;
